import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio';
import { AppPreferences } from '../../shared/local/app-preferences.local';

@Injectable()
export class FingerprintService {
    SFGoAuth: any;
    constructor(private platform: Platform, private faio: FingerprintAIO, public appPreferences: AppPreferences) {}

    async getClientId() {
        this.SFGoAuth = this.appPreferences.getAuth();
    }
    async checkIsCordova() {
        await this.platform.ready();
        if (this.platform.is('cordova')) return true;
    }

    async show() {
        await this.getClientId();
        return this.faio.show({
            clientId: this.SFGoAuth.id,
            clientSecret: 'password', //Only necessary for Android
            disableBackup: true, //Only for Android(optional)
            localizedFallbackTitle: 'Use Pin', //Only for iOS
            localizedReason: 'Please authenticate', //Only for iOS
        });
    }

    async isAvailable() {
        return this.faio.isAvailable();
    }
}



// WEBPACK FOOTER //
// ./src/providers/fingerprint/fingerprint.service.ts